import z from "zod";
import { PaginationResponseSchema, PaginationSchema } from "../common";
import {
  BlogTranslationSchema,
  CreateBlogTranslationSchema,
  SeedBlogTranslationSchema,
  UpdateBlogTranslationSchema,
} from "./blog-translation";

const PopulatedBlogSchema = z.object({
  id: z.uuidv7(),
  slug: z.string().min(1, "Slug is required"),
  published: z.boolean().default(false),
  code: z.string().min(1, "Code is required"),
  createdAt: z.date(),
  updatedAt: z.date(),
  translations: BlogTranslationSchema,
  titleEn: z.string().optional(),
  titleAr: z.string().optional(),
  titleTr: z.string().optional(),
  titleFa: z.string().optional(),
});

export const BlogSchemas = {
  list: {
    request: PaginationSchema.extend({
      exclude: z.uuidv7().optional().catch(undefined),
      slug: z.string().optional(),
      published: z.boolean().optional(),
      sort: z.string().optional(),
    }),
    response: PaginationResponseSchema(PopulatedBlogSchema),
  },

  find: z.object({ id: z.string() }),

  getRedirect: z.object({ slug: z.string() }),

  create: z.object({
    slug: z.string().optional(),
    published: z.boolean(),
    translations: CreateBlogTranslationSchema,
  }),

  seed: z
    .object({
      id: z.uuidv7(),
      slug: z.string().min(1, "Slug is required"),
      published: z.boolean(),
      translations: SeedBlogTranslationSchema.array(),
    })
    .array(),

  update: z.object({
    id: z.uuidv7(),
    slug: z.string().optional(),
    published: z.boolean(),
    translations: UpdateBlogTranslationSchema,
  }),

  delete: z.object({ id: z.uuidv7() }),
};

export type PopulatedBlog = z.infer<typeof PopulatedBlogSchema>;
export type CreateBlog = z.infer<typeof BlogSchemas.create>;
export type UpdateBlog = z.infer<typeof BlogSchemas.update>;
